<template lang="pug">
.exchange-item-card
  .exchange-item-img
    img(:src="item.image" @click="$emit('detail', item)")
    .exchange-item-tag(v-if="!hideBonus && item.pointsDeduction && item.salePriceAfterDeduction")
      | {{ item.pointsDeduction }}币+{{ item.salePriceAfterDeduction }}元立得
  .exchange-item-container
    .exchange-title {{ item.title }}
    .exchange-subtitle {{ item.subtitle }}
    .exchange-btn-line
      .exchange-btn-left
        img.exchange-btn-left-img(:src="coinIcon")
        .exchange-btn-left-money {{ item.amount }}
      .exchange-btn-right(@click="$emit('exchange', item)") 兑换
</template>

<script>
export default {
  name: 'ExchangeItemCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
    coinIcon: {
      type: String,
      default: 'https://m.hellobike.com/fd018348_new_coin.png',
    },
    // 是否隐藏积分+现金标签（旧版不展示）
    hideBonus: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.exchange-item-card {
  width: 1.71rem;
  height: 2.19rem;
  border-radius: 0.12rem;
  // margin-bottom: 0.12rem;
  background-color: #fff;
  box-sizing: border-box;

  .exchange-item-img {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 1.32rem;
    border: 0.01rem solid #fff;
    border-radius: 0.12rem 0.12rem 0 0;
    background-color: #f1faff;

    img {
      width: 100%;
      height: 100%;
    }

    .exchange-item-tag {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0.2rem;
      line-height: 0.2rem;
      padding-left: 0.12rem;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(8px);
      font-family: PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      color: #fff;
      opacity: 0.9;
    }
  }

  .exchange-item-container {
    padding: 0.1rem 0.13rem 0 0.12rem;

    .exchange-title {
      font-weight: 500;
      font-size: 0.14rem;
      line-height: 0.15rem;
      color: #242729;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
    }

    .exchange-subtitle {
      margin-top: 0.04rem;
      font-weight: 400;
      font-size: 0.12rem;
      line-height: 0.17rem;
      color: #879099;
    }

    .exchange-btn-line {
      margin-top: 0.04rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .exchange-btn-left {
        display: flex;
        align-items: center;

        .exchange-btn-left-img {
          width: 0.16rem;
          height: 0.16rem;
        }

        .exchange-btn-left-money {
          font-weight: 500;
          font-size: 0.14rem;
          line-height: normal;
          margin-left: 0.04rem;
          color: #ff5c0a;
        }
      }

      .exchange-btn-right {
        width: 0.47rem;
        height: 0.24rem;
        text-align: center;
        border-radius: 0.2rem;
        background: #ffe4b6;
        line-height: 0.24rem;
        color: #784117;
        font-size: 0.12rem;
        font-weight: 600;
      }
    }
  }
}
</style>
